(function ($) {
  'use strict';

  var $container = $('#awlr-telemetry-chart-container-new');
  var $empty = $('#awlr-telemetry-chart-empty');
  var $loading = $('#awlr-telemetry-chart-loading');
  var $title = $('#awlr-telemetry-chart-title');
  var $time = $('#waktu');
  var $periode = $('#periode');
  var $unitDisplay = $('#unit-display');
  var chart = null;
  var stationType = $('#station-type2').val();
  var PeilschaalBasisElevation =
    Number($('#PeilschaalBasisElevation').val()) || 0;

  if (!$container.length) {
    return;
  }

  console.log('unitDisplay: ', $unitDisplay.val());
  var telemetryChartAjaxGuard =
    typeof createTelemetryChartLoadGuard === 'function'
      ? createTelemetryChartLoadGuard()
      : {
          start: function () {
            return {
              isCurrent: function () {
                return true;
              },
              register: function () {},
              clearIfCurrent: function () {},
            };
          },
        };

  function getSelectedTime() {
    return $time.length && $time.val() ? $time.val() : 'minute';
  }

  function getUnit() {
    return $unitDisplay.length && $unitDisplay.val() ? $unitDisplay.val() : 'm';
  }

  function normalizeFilterDate(selectedTime, value) {
    var raw = (value || '').trim();
    var monthNameFormats = ['MMMM YYYY', 'MMM YYYY'];
    var dayNameFormats = ['D MMMM YYYY', 'DD MMMM YYYY', 'D MMM YYYY'];

    if (selectedTime === 'day') {
      if (moment(raw, 'YYYY', true).isValid()) {
        return moment(raw, 'YYYY', true).format('YYYY');
      }

      if (moment(raw, 'YYYY-MM', true).isValid()) {
        return moment(raw, 'YYYY-MM', true).format('YYYY');
      }

      if (moment(raw, 'YYYY-MM-DD', true).isValid()) {
        return moment(raw, 'YYYY-MM-DD', true).format('YYYY');
      }

      var dayParsed = moment(raw, dayNameFormats, 'id', true);
      if (!dayParsed.isValid()) {
        dayParsed = moment(raw, dayNameFormats, true);
      }
      if (dayParsed.isValid()) {
        return dayParsed.format('YYYY');
      }

      var monthParsedForYear = moment(raw, monthNameFormats, 'id', true);
      if (!monthParsedForYear.isValid()) {
        monthParsedForYear = moment(raw, monthNameFormats, true);
      }
      if (monthParsedForYear.isValid()) {
        return monthParsedForYear.format('YYYY');
      }

      return moment().format('YYYY');
    }

    if (selectedTime === 'hour') {
      if (moment(raw, 'YYYY-MM', true).isValid()) {
        return moment(raw, 'YYYY-MM', true).format('YYYY-MM');
      }

      if (moment(raw, 'YYYY-MM-DD', true).isValid()) {
        return moment(raw, 'YYYY-MM-DD', true).format('YYYY-MM');
      }

      var monthParsed = moment(raw, monthNameFormats, 'id', true);
      if (!monthParsed.isValid()) {
        monthParsed = moment(raw, monthNameFormats, true);
      }
      if (monthParsed.isValid()) {
        return monthParsed.format('YYYY-MM');
      }

      if (moment(raw, 'YYYY', true).isValid()) {
        return moment().year(Number(raw)).format('YYYY-MM');
      }

      return moment().format('YYYY-MM');
    }

    if (moment(raw, 'YYYY-MM-DD', true).isValid()) {
      return moment(raw, 'YYYY-MM-DD', true).format('YYYY-MM-DD');
    }

    var dayParsedMinute = moment(raw, dayNameFormats, 'id', true);
    if (!dayParsedMinute.isValid()) {
      dayParsedMinute = moment(raw, dayNameFormats, true);
    }
    if (dayParsedMinute.isValid()) {
      return dayParsedMinute.format('YYYY-MM-DD');
    }

    if (moment(raw, 'YYYY-MM', true).isValid()) {
      return moment(raw, 'YYYY-MM', true).startOf('month').format('YYYY-MM-DD');
    }

    var monthParsedMinute = moment(raw, monthNameFormats, 'id', true);
    if (!monthParsedMinute.isValid()) {
      monthParsedMinute = moment(raw, monthNameFormats, true);
    }
    if (monthParsedMinute.isValid()) {
      return monthParsedMinute.startOf('month').format('YYYY-MM-DD');
    }

    if (moment(raw, 'YYYY', true).isValid()) {
      return moment(raw, 'YYYY', true).startOf('year').format('YYYY-MM-DD');
    }

    return moment().format('YYYY-MM-DD');
  }

  function getFilterDate(selectedTime) {
    var value = $periode.length ? $periode.val() : '';
    return normalizeFilterDate(selectedTime, value);
  }

  function capitalizeFirst(text) {
    if (!text) {
      return '';
    }

    return text.charAt(0).toUpperCase() + text.slice(1);
  }

  function getSubtitleText(selectedTime, filterDate) {
    var now = moment();

    if (selectedTime === 'day') {
      var yearMoment = moment(filterDate, 'YYYY', true).isValid()
        ? moment(filterDate, 'YYYY', true)
        : moment(filterDate, 'YYYY-MM', true).isValid()
          ? moment(filterDate, 'YYYY-MM', true)
          : moment(filterDate, 'YYYY-MM-DD', true).isValid()
            ? moment(filterDate, 'YYYY-MM-DD', true)
            : now.clone();
      var yearStart = yearMoment.clone().startOf('year');
      var yearEnd = yearMoment.isSame(now, 'year')
        ? now.clone().startOf('day')
        : yearMoment.clone().endOf('year');
      return (
        'Periode ' +
        capitalizeFirst(yearStart.locale('id').format('DD MMMM YYYY')) +
        ' sampai ' +
        capitalizeFirst(yearEnd.locale('id').format('DD MMMM YYYY'))
      );
    }

    if (selectedTime === 'hour') {
      var monthMoment = moment(filterDate, 'YYYY-MM', true).isValid()
        ? moment(filterDate, 'YYYY-MM', true)
        : moment(filterDate, 'YYYY-MM-DD', true).isValid()
          ? moment(filterDate, 'YYYY-MM-DD', true)
          : now.clone();
      var monthStart = monthMoment.clone().startOf('month');
      var monthEnd = monthMoment.isSame(now, 'month')
        ? now.clone().startOf('day')
        : monthMoment.clone().endOf('month');
      return (
        'Periode ' +
        capitalizeFirst(monthStart.locale('id').format('DD MMMM')) +
        ' sampai ' +
        capitalizeFirst(monthEnd.locale('id').format('DD MMMM YYYY'))
      );
    }

    var minuteMoment = moment(filterDate, 'YYYY-MM-DD', true).isValid()
      ? moment(filterDate, 'YYYY-MM-DD', true)
      : now.clone();
    return (
      'Periode ' +
      capitalizeFirst(minuteMoment.locale('id').format('DD MMMM YYYY'))
    );
  }

  function getChartMeta(selectedTime) {
    var label = 'Tinggi Muka Air';

    if (selectedTime === 'minute') {
      return {
        title: 'Grafik ' + label + ' Per 5 Menit',
        tooltipFormat: 'D MMMM YYYY HH:mm',
      };
    }

    if (selectedTime === 'day') {
      return {
        title: 'Grafik ' + label + ' Harian',
        tooltipFormat: 'D MMMM YYYY',
      };
    }

    return {
      title: 'Grafik ' + label + ' Jam-Jaman',
      tooltipFormat: 'D MMMM YYYY HH:mm',
    };
  }

  function getReadingField(selectedTime) {
    if (selectedTime === 'day') {
      return 'readingDate';
    }

    if (selectedTime === 'hour') {
      return 'readingHour';
    }

    return 'readingAt';
  }

  function getValueField(selectedTime) {
    if (selectedTime === 'day') {
      return 'waterLevelAvg';
    }

    return 'waterLevel';
  }

  function getXAxisLabelFormat(selectedTime) {
    if (selectedTime === 'day') {
      return 'DD MMM YYYY';
    }

    return 'DD MMM YYYY HH:mm';
  }

  function toSiagaConfig(response) {
    var raw = (response && (response.dataSiaga || response.DataSiaga)) || null;
    if (!raw) {
      return null;
    }

    var siaga1 = Number(raw.siaga1 != null ? raw.siaga1 : raw.Siaga1);
    var siaga2 = Number(raw.siaga2 != null ? raw.siaga2 : raw.Siaga2);
    var siaga3 = Number(raw.siaga3 != null ? raw.siaga3 : raw.Siaga3);

    if (
      !Number.isFinite(siaga1) ||
      !Number.isFinite(siaga2) ||
      !Number.isFinite(siaga3)
    ) {
      return null;
    }

    return {
      siaga1: siaga1,
      siaga2: siaga2,
      siaga3: siaga3,
    };
  }

  function getAwlrRange(selectedTime, filterDate) {
    if (selectedTime === 'day') {
      var yearMoment = moment(filterDate, 'YYYY', true).isValid()
        ? moment(filterDate, 'YYYY', true)
        : moment();

      return {
        startDate: yearMoment.startOf('year').format('YYYY-MM-DD'),
        endDate: yearMoment.endOf('year').format('YYYY-MM-DD'),
      };
    }

    if (selectedTime === 'hour') {
      var monthMoment = moment(filterDate, 'YYYY-MM', true).isValid()
        ? moment(filterDate, 'YYYY-MM', true)
        : moment();

      return {
        startDate: monthMoment.startOf('month').format('YYYY-MM-DD'),
        endDate: monthMoment.endOf('month').format('YYYY-MM-DD'),
      };
    }

    var dayMoment = moment(filterDate, 'YYYY-MM-DD', true).isValid()
      ? moment(filterDate, 'YYYY-MM-DD', true)
      : moment();

    return {
      startDate: dayMoment.format('YYYY-MM-DD'),
      endDate: dayMoment.format('YYYY-MM-DD'),
    };
  }

  function loadSiagaConfig(selectedTime, filterDate) {
    var range = getAwlrRange(selectedTime, filterDate);

    return $.ajax({
      url: '/Station/GetDataGrafikAwlr',
      type: 'POST',
      data: {
        deviceId: deviceId,
        startDate: range.startDate,
        endDate: range.endDate,
      },
    }).then(
      function (response) {
        return toSiagaConfig(response);
      },
      function () {
        return null;
      },
    );
  }

  function buildSiagaSeries(points, siagaConfig) {
    if (!siagaConfig || !points.length) {
      return [];
    }

    var maxObserved = Math.max.apply(
      null,
      points.map(function (point) {
        return Number(point.y);
      }),
    );

    if (!Number.isFinite(maxObserved)) {
      return [];
    }

    var xValues = points.map(function (point) {
      return point.x;
    });

    function formatLegendSiaga(v) {
      if (typeof formatTelemetryTooltipNumber === 'function') {
        return formatTelemetryTooltipNumber(v);
      }
      var n = Number(v);
      return Number.isFinite(n)
        ? n.toLocaleString('en-US', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 3,
          })
        : String(v);
    }

    var createSeries = function (name, value, color, isActive) {
      var u = getUnit();
      var displayName =
        name + ' (' + formatLegendSiaga(value) + (u ? ' ' + u : '') + ')';
      return {
        name: displayName,
        type: 'line',
        data: xValues.map(function (x) {
          return [x, value];
        }),
        marker: { enabled: false },
        lineWidth: 1,
        dashStyle: 'Dash',
        color: color,
        dataLabels: {
          enabled: true,
          allowOverlap: false,
          formatter: function () {
            return this.point.index === 0
              ? '<span style="color:' +
                  this.color +
                  ';font-weight:bold;">' +
                  this.series.name +
                  '</span>'
              : null;
          },
        },
        enableMouseTracking: false,
        showInLegend: true,
        visible: isActive,
        zIndex: 5,
        custom: {
          axisRole: 'threshold',
          thresholdValue: value,
        },
        events: {
          show: function () {
            if (typeof onThresholdSeriesVisibility === 'function') {
              onThresholdSeriesVisibility.call(this);
            }
          },
          hide: function () {
            if (typeof onThresholdSeriesVisibility === 'function') {
              onThresholdSeriesVisibility.call(this);
            }
          },
        },
      };
    };

    var activeWaspada = maxObserved >= siagaConfig.siaga3;
    var activeSiaga = maxObserved >= siagaConfig.siaga2;
    var activeAwas = maxObserved >= siagaConfig.siaga1;

    return [
      createSeries('AWAS', siagaConfig.siaga1, '#EF5350', activeAwas),
      createSeries('SIAGA', siagaConfig.siaga2, '#FFA602', activeSiaga),
      createSeries('WASPADA', siagaConfig.siaga3, '#FFDA4F', activeWaspada),
    ];
  }

  function toPoints(rows, selectedTime) {
    var readingField = getReadingField(selectedTime);
    var valueField = getValueField(selectedTime);

    return rows
      .map(function (row) {
        var rawDate = row[readingField];
        var value = Number(row[valueField]);
        var timestamp = moment.utc(rawDate).valueOf();
        var minValue = Number(row.waterLevelMin);
        var maxValue = Number(row.waterLevelMax);

        return {
          x: timestamp,
          y: value,
          yMin: Number.isFinite(minValue) ? minValue : null,
          yMax: Number.isFinite(maxValue) ? maxValue : null,
          warningStatus: row.warningStatus,
        };
      })
      .filter(function (point) {
        return Number.isFinite(point.x) && Number.isFinite(point.y);
      })
      .sort(function (a, b) {
        return a.x - b.x;
      });
  }

  function showEmpty(message) {
    if (chart) {
      chart.destroy();
      chart = null;
    }

    $container.hide();
    $loading.hide();
    $empty.text(message).show();
  }

  function showLoading() {
    $empty.hide();
    $container.hide();
    $loading.css('display', 'block');
  }

  function hideLoading() {
    $loading.hide();
  }

  function getWarningText(warningStatus, value, siagaConfig) {
    if (warningStatus === 1 || warningStatus === '1') {
      return 'Awas';
    }

    if (warningStatus === 2 || warningStatus === '2') {
      return 'Siaga';
    }

    if (warningStatus === 3 || warningStatus === '3') {
      return 'Waspada';
    }

    if (warningStatus === 4 || warningStatus === '4') {
      return 'Normal';
    }

    var numericValue = Number(value);
    if (Number.isFinite(numericValue) && siagaConfig) {
      if (numericValue >= Number(siagaConfig.siaga1)) {
        return 'Awas';
      }

      if (numericValue >= Number(siagaConfig.siaga2)) {
        return 'Siaga';
      }

      if (numericValue >= Number(siagaConfig.siaga3)) {
        return 'Waspada';
      }
    }

    return 'Normal';
  }

  function getDailySeries(points, waterLabel, baseColor) {
    var avgData = points.map(function (point) {
      return {
        x: point.x,
        y: point.y,
        yMin: point.yMin,
        yMax: point.yMax,
      };
    });

    var avgSeries = {
      name: waterLabel + ' Rata-rata',
      type: 'line',
      data: avgData,
      color: baseColor,
      lineWidth: 2,
      zIndex: 1,
      custom: {
        dailyType: 'avg',
      },
      marker: {
        enabled: true,
        radius: 1,
        fillColor: '#FFFFFF',
        lineWidth: 2,
        lineColor: baseColor,
      },
    };

    var supportsRange =
      !!(Highcharts.seriesTypes && Highcharts.seriesTypes.arearange) ||
      !!(Highcharts.seriesTypes && Highcharts.seriesTypes.areasplinerange);

    if (supportsRange) {
      var rangeType = Highcharts.seriesTypes.arearange
        ? 'arearange'
        : 'areasplinerange';

      return [
        avgSeries,
        {
          name: waterLabel + ' Min-Maks',
          type: rangeType,
          data: points
            .filter(function (point) {
              return Number.isFinite(point.yMin) && Number.isFinite(point.yMax);
            })
            .map(function (point) {
              return [point.x, point.yMin, point.yMax];
            }),
          linkedTo: ':previous',
          color: baseColor,
          fillOpacity: 0.3,
          lineWidth: 0,
          custom: {
            dailyType: 'range',
          },
          marker: {
            enabled: false,
          },
          zIndex: 0,
        },
      ];
    }

    // Fallback aman: jika modul arearange belum aktif, tampilkan rata-rata saja
    // agar tidak menjadi 3 garis yang membingungkan.
    return [avgSeries];
  }

  function renderChart(points, selectedTime, filterDate, siagaConfig) {
    var meta = getChartMeta(selectedTime);
    var subtitleText = getSubtitleText(selectedTime, filterDate);
    var xAxisLabelFormat = getXAxisLabelFormat(selectedTime);
    var waterLabel = 'TMA';
    var unit = getUnit();
    var baseColor = '#7CB5EC';

    var yValues = points.map((p) => p.y);

    var minTma = Math.min.apply(null, yValues);
    var maxTma = Math.max.apply(null, yValues);

    // EMA = TMA + elevation
    var minEma = minTma + PeilschaalBasisElevation;
    var maxEma = maxTma + PeilschaalBasisElevation;

    // safety kalau flat
    if (minEma === maxEma) {
      maxEma += 1;
    }

    // kasih sedikit padding biar gak nempel
    var padding = (maxTma - minTma) * 0.1;

    if (padding === 0) {
      padding = 0.1; // fallback kalau flat
    }

    var finalMinTma = minTma - padding;
    var finalMaxTma = maxTma + padding;

    function buildTmaAreaFill(color) {
      return {
        linearGradient: {
          x1: 0,
          y1: 1,
          x2: 0,
          y2: 0,
        },
        stops: [
          [0, Highcharts.color(color).setOpacity(0.55).get('rgba')],
          [1, Highcharts.color(color).setOpacity(0.05).get('rgba')],
        ],
      };
    }

    var siagaSeries =
      selectedTime === 'day' ? [] : buildSiagaSeries(points, siagaConfig);
    var primarySeries =
      selectedTime === 'day'
        ? getDailySeries(points, waterLabel, baseColor)
        : [
            {
              name: waterLabel,
              type: 'areaspline',
              data: points,
              color: baseColor,
              threshold: finalMinTma,
              softThreshold: false,
              fillColor: buildTmaAreaFill(baseColor),
            },
          ];
    var emaSeries =
      Number.isFinite(PeilschaalBasisElevation) && PeilschaalBasisElevation > 0
        ? [
            {
              name: 'EMA',
              type: 'line',
              data: points.map(function (p) {
                return [p.x, p.y + PeilschaalBasisElevation];
              }),

              // 🔥 bikin invisible tapi tetap "hidup"
              lineWidth: 0,
              color: 'transparent',

              marker: {
                enabled: false,
              },

              enableMouseTracking: true,
              showInLegend: false,

              tooltip: {
                valueSuffix: ' mdpl',
              },
            },
          ]
        : [];

    $title.text(meta.title);
    $empty.hide();
    hideLoading();
    $container.show();

    if (chart) {
      chart.destroy();
      chart = null;
    }

    chart = Highcharts.chart('awlr-telemetry-chart-container-new', {
      chart: {
        type: 'areaspline',
        zoomType: 'x',
      },
      legend: {
        enabled: true,
        align: 'center',
        verticalAlign: 'bottom',
        layout: 'horizontal',
        floating: false,
        itemStyle: {
          fontSize: '11px',
          fontWeight: 'normal',
        },
        // Pastikan zIndex lebih tinggi agar tidak tertutup elemen lain
        zIndex: 100,
      },
      navigator: {
        enabled: true,
        height: 25, // Dikecilkan ukurannya (sebelumnya mungkin 40-50)
        margin: 5, // Mengurangi jarak antar elemen
        xAxis: {
          labels: {
            style: { fontSize: '9px' }, // Font kecil agar proporsional
            dateTimeLabelFormats: {
              hour: '%H:%M', // Tetap format 24 jam
              minute: '%H:%M',
            },
          },
        },
      },
      title: {
        text: meta.title,
      },
      subtitle: {
        text: subtitleText,
      },
      xAxis: {
        type: 'datetime',
        gridLineWidth: 0,
        lineWidth: 1,
        title: {
          text: 'Waktu',
        },
        labels: {
          rotation: -45,
          formatter: function () {
            return moment.utc(this.value).locale('id').format(xAxisLabelFormat);
          },
        },
      },
      yAxis: [
        {
          title: {
            text: waterLabel + ' (' + unit + ')',
          },
          min: finalMinTma,
          max: finalMaxTma,
          minPadding: 0,
          maxPadding: 0.08,
          startOnTick: false,
          endOnTick: false,
          floor: finalMinTma,
          gridLineWidth: 0,
        },
        ...(PeilschaalBasisElevation > 0
          ? [
              {
                title: {
                  text: 'EMA (mdpl)',
                },
                opposite: true, // kanan
                min: minEma,
                max: maxEma,
                gridLineWidth: 0,
              },
            ]
          : []),
      ],
      tooltip: {
        shared: true, // 🔥 WAJIB biar EMA ikut
        crosshairs: true,
        formatter: function () {
          var fmt =
            typeof formatTelemetryTooltipNumber === 'function'
              ? formatTelemetryTooltipNumber
              : function (v) {
                  return String(v);
                };
          var dateLabel = moment
            .utc(this.x)
            .locale('id')
            .format(meta.tooltipFormat);

          // =============================
          // MODE DAY (tetap seperti kamu)
          // =============================
          if (selectedTime === 'day') {
            var rows = ['<b>' + dateLabel + '</b>'];

            if (this.points && this.points.length) {
              var avgPoint = this.points.find(function (point) {
                return (
                  point.series &&
                  point.series.userOptions &&
                  point.series.userOptions.custom &&
                  point.series.userOptions.custom.dailyType === 'avg'
                );
              });

              var rangePoint = this.points.find(function (point) {
                return (
                  point.point &&
                  Number.isFinite(point.point.low) &&
                  Number.isFinite(point.point.high)
                );
              });

              if (avgPoint) {
                rows.push(
                  waterLabel +
                    ' Rata-rata: <b>' +
                    fmt(avgPoint.y) +
                    ' ' +
                    unit +
                    '</b>',
                );
              }

              if (rangePoint) {
                rows.push(
                  'Range: <b>' +
                    fmt(rangePoint.point.low) +
                    ' ' +
                    unit +
                    ' - ' +
                    fmt(rangePoint.point.high) +
                    ' ' +
                    unit +
                    '</b>',
                );
              } else if (
                avgPoint &&
                avgPoint.point &&
                Number.isFinite(avgPoint.point.yMin) &&
                Number.isFinite(avgPoint.point.yMax)
              ) {
                rows.push(
                  'Range: <b>' +
                    fmt(avgPoint.point.yMin) +
                    ' ' +
                    unit +
                    ' - ' +
                    fmt(avgPoint.point.yMax) +
                    ' ' +
                    unit +
                    '</b>',
                );
              }
            } else {
              rows.push(
                waterLabel + ': <b>' + fmt(this.y) + ' ' + unit + '</b>',
              );
            }

            return rows.join('<br/>');
          }

          // =============================
          // MODE NORMAL (INI YANG DIPERBAIKI)
          // =============================
          var rows = ['<b>' + dateLabel + '</b>'];

          if (this.points && this.points.length) {
            this.points.forEach(function (p) {
              if (p.series.name === 'EMA') {
                rows.push('EMA: <b>' + fmt(p.y) + ' mdpl</b>');
              } else {
                rows.push(
                  p.series.name + ': <b>' + fmt(p.y) + ' ' + unit + '</b>',
                );
              }
            });
          } else {
            // fallback (kalau shared gagal)
            rows.push(waterLabel + ': <b>' + fmt(this.y) + ' ' + unit + '</b>');
          }

          var mainPoint =
            this.points?.find((p) => p.series.name !== 'EMA') || this.point;

          var warningText = getWarningText(
            mainPoint?.point?.warningStatus,
            mainPoint?.y,
            siagaConfig,
          );

          rows.push('Status: <b>' + warningText + '</b>');

          return rows.join('<br/>');
        },
      },
      plotOptions: {
        line: {
          softThreshold: true,
        },
        areaspline: {
          softThreshold: false,
          marker: {
            enabled: true,
            radius: 1,
          },
          lineWidth: 2,
          lineColor: baseColor,
          fillColor: buildTmaAreaFill(baseColor),
          animation: {
            duration: 500,
          },
        },
      },
      series: primarySeries.concat(emaSeries).concat(siagaSeries),
      credits: {
        enabled: false,
      },
    });

    var thresholdAxes = [
      {
        axisIndex: 0,
        min: finalMinTma,
        max: finalMaxTma,
        syncFloor: true,
      },
    ];
    if (Number.isFinite(PeilschaalBasisElevation) && PeilschaalBasisElevation > 0) {
      thresholdAxes.push({
        axisIndex: 1,
        min: minEma,
        max: maxEma,
        followAxisIndex: 0,
      });
    }
    chart.__thresholdAxisBase = {
      fitting: false,
      axes: thresholdAxes,
    };
    if (typeof fitChartAxesToVisibleThresholds === 'function') {
      fitChartAxesToVisibleThresholds(chart, true);
    }
  }

  function loadRealChart() {
    if (typeof Highcharts === 'undefined') {
      showEmpty('Highcharts belum tersedia.');
      return;
    }

    var selectedTime = getSelectedTime();
    var filterDate = getFilterDate(selectedTime);

    var g = telemetryChartAjaxGuard.start();
    showLoading();

    function guardFail(_xhr, status) {
      if (status === 'abort') {
        return;
      }
      if (!g.isCurrent()) {
        return;
      }
      showEmpty('Gagal memuat data grafik.');
    }

    if (selectedTime === 'day') {
      var chartXhrDay = $.ajax({
        url: '/Station/GetChartDataAwlr',
        type: 'POST',
        data: {
          deviceId: deviceId,
          selectedTime: selectedTime,
          filterDate: filterDate,
        },
      });
      g.register(chartXhrDay);

      chartXhrDay
        .done(function (response) {
          if (!g.isCurrent()) {
            return;
          }
          var rows = response && response.data ? response.data : [];
          var points = toPoints(rows, selectedTime);

          if (!points.length) {
            showEmpty('Data grafik tidak tersedia.');
            return;
          }

          renderChart(points, selectedTime, filterDate, null);
        })
        .fail(guardFail)
        .always(function () {
          g.clearIfCurrent();
        });

      return;
    }

    var chartXhr = $.ajax({
      url: '/Station/GetChartDataAwlr',
      type: 'POST',
      data: {
        deviceId: deviceId,
        selectedTime: selectedTime,
        filterDate: filterDate,
      },
    });
    g.register(chartXhr);

    $.when(chartXhr, loadSiagaConfig(selectedTime, filterDate))
      .done(function (tableResponse, siagaResponse) {
        if (!g.isCurrent()) {
          return;
        }
        var response =
          tableResponse && tableResponse[0] ? tableResponse[0] : tableResponse;
        var siagaConfig =
          siagaResponse && siagaResponse[0] ? siagaResponse[0] : siagaResponse;
        var rows = response && response.data ? response.data : [];
        var points = toPoints(rows, selectedTime);

        if (!points.length) {
          showEmpty('Data grafik tidak tersedia.');
          return;
        }

        renderChart(points, selectedTime, filterDate, siagaConfig);
      })
      .fail(guardFail)
      .always(function () {
        g.clearIfCurrent();
      });
  }

  function init() {
    if ($time.length) {
      $time.on('change', loadRealChart);
    }

    if ($periode.length) {
      $periode.on('change', loadRealChart);
    }

    $('a[data-bs-toggle="tab"][href="#tab-data-telemetri"]').on(
      'shown.bs.tab',
      function () {
        loadRealChart();
      },
    );

    loadRealChart();
  }

  init();
})(jQuery);
